<template>
  <b-thead>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <b-tr>
      <b-th class="align-middle" v-for="(field, index) in fields" :key="index"
            :style="index === 1 ? 'width: 12rem;':''">
        <span v-if="!field.filtro">{{ field.label }}</span>
        <date-picker :lang="idiomaCalendario" size="sm" v-if="field.filtro && field.tipoFiltro === 'fecha'"
                     v-model="field.valor" range value-type="format" :editable="false" :placeholder="field.label"
                     :disabled-date="bloquearDiasDespuesDeHoy" @input="obtener(index)">
        </date-picker>
        <div v-if="field.filtro && field.tipoFiltro === 'select'" class="custom" ref="customSelect">
          <div class="select-header text-center" @click="toggleOptions">
            {{ field.valor.text || 'Todas las solicitudes' }}
            <span class="arrow-down"></span>
          </div>
          <ul class="select-options text-center" v-show="showOptions">
            <li v-for="option in field.options" :key="option" @click="selectOption(option, index)">{{
                option.text
              }}
            </li>
          </ul>
        </div>
      </b-th>
    </b-tr>
  </b-thead>
</template>
<script>
export default {
  name: "BandejaFiltros",
  props: {
    fields: {type: Array, required: true}
  },
  data() {
    return {
      version: process.env.VUE_APP_ENV_VERSION,
      debug: false,
      loader: false,
      showOptions: false,
      idiomaCalendario: {
        formatLocale: {
          // MMMM
          months: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
          // MMM
          monthsShort: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
          // dd
          weekdaysMin: ['Dom', 'Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb'],
        },
        monthFormat: 'MMMM',
      }
    }
  },
  created() {
    this.debug = this.$localStorageService.getDebug();
  },
  methods: {
    bloquearDiasDespuesDeHoy(date) {
      const today = new Date();
      today.setHours(0, 0, 0, 0);

      return date > today;
    },
    obtener(index) {
      this.fields = this.fields.map((e, index) => {
        return { ...e, index: index };
      })
      this.$emit('fieldsTable', this.fields, index);
    },
    toggleOptions() {
      this.showOptions = !this.showOptions;
    },
    selectOption(option, index) {
      this.fields = this.fields.map((e, index) => {
        return { ...e, index: index };
      })
      this.fields[index].valor = option;
      this.showOptions = false;
      this.$emit('fieldsTable', this.fields, index);
      //this.obtener();
    },
  }
}
</script>
<style scoped>

</style>
